@use "../../../../../scss/settings/colors";
@use "../../../../../scss/settings/breakpoints";

// Employment requirement palette (from the Library mockup)
$requirement-row-green-bg: #f2faf4;
$requirement-green-text: #1b6b3a;
$requirement-green-bg: #e3f4e8;
$requirement-blue-text: #1e3a8a;
$requirement-blue-bg: #e6edfb;
$requirement-orange-text: #8a4a0a;
$requirement-orange-bg: #fdf0dc;
$requirement-purple-text: #5b21b6;
$requirement-purple-bg: #efe7fb;
$requirement-gray-text: #4b5563;
$requirement-gray-bg: #eef0f3;

.copymodal {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  width: 50% !important;
  top: 0 !important;
  left: 25% !important;
  margin: 0;
  padding: 0;
}

.table_container {
  box-shadow: none;
  border: 1px solid colors.$gray-variant-4;
  border-radius: 16px;

  // Inside the Library page block the block itself draws the border and the rounded corners.
  &.table_container_embedded {
    // 100vh minus the app header, the page description and the action bar above the table.
    max-height: calc(100vh - 110px);
    border: none;
    border-radius: 0;

    @media #{breakpoints.$tablet-mobile}{
      max-height: none;
    }
  }
}

.library_table {
  border-collapse: separate;
}

.library_table {
  border-collapse: separate;
}

.profile_container,
.file_type_container,
.date_container {
  display: flex;
  align-items: center;
  gap: 8px;
}

// Name cell: the title line (name + Free tag) with the document type and date underneath.
.profile_container {
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.title_container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.subtitle_text:global(.MuiTypography-root) {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-family: "Regular Inter", sans-serif;
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: colors.$gray-variant-16;
}

.subtitle_separator {
  margin: 0 6px;
}


.profile_icon,
.file_type_icon {
  display: flex;
  align-items: center;
  color: colors.$dark-blue;

  svg {
    fill: colors.$dark-blue;
  }

  .MuiSvgIcon-root {
    width: 24px !important;
    height: 24px !important;
  }

}

.profile_icon {
  width: 24px;
  height: 24px;
  justify-content: center;
}


.actions_container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-left: 8px;

  .action_button {
    flex-shrink: 0;

    svg {
      fill: colors.$dark-blue !important;
    }


    &:hover {

      svg {
        fill: colors.$dark-blue !important;
      }

    }

  }

}

.table_row {
  cursor: pointer;

  :global(.MuiTableCell-root) {
    border-bottom: 1px solid colors.$gray-variant-4;
  }

  &:last-child :global(.MuiTableCell-root) {
    border-bottom: none;
  }

  &:hover {
    background-color: colors.$gray-variant-20;
  }

  &.table_row_required {
    background-color: $requirement-row-green-bg;
  }
}

.table_cell, .table_cell_title_container {
  padding: 12px 16px;

  .cell_text {
    color: colors.$dark-blue;
  }

}

// The name column takes all the free width; the Requirement and actions columns shrink to fit.
.table_cell_title_container {
  width: 100%;
  min-width: 220px;
}

.requirement_cell,
.actions_cell {
  width: 1%;
  white-space: nowrap;
}

.actions_cell {
  padding-left: 0;
}

.row_actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

// Fixed-size slot for the description (info) icon, empty when the item has no description.
.info_slot {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
}

.profile_text:global(.MuiTypography-root) {
  font-family: "Bold Inter", sans-serif !important;
  //font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: colors.$dark-blue;

  //&.profile_text_required {
    //font-weight: 700;
  //}
}

// ---------- Employment requirement badges ----------
.requirement_badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.25rem;
  white-space: nowrap;
}

.requirement_badge_green {
  color: $requirement-green-text;
  background-color: $requirement-green-bg;
}

.requirement_badge_blue {
  color: $requirement-blue-text;
  background-color: $requirement-blue-bg;
}

.requirement_badge_orange {
  color: $requirement-orange-text;
  background-color: $requirement-orange-bg;
}

.requirement_badge_purple {
  color: $requirement-purple-text;
  background-color: $requirement-purple-bg;
}

.requirement_badge_gray {
  color: $requirement-gray-text;
  background-color: $requirement-gray-bg;
}

.header_text {
  color: colors.$dark-blue;
}

// ---------- Requirement filter ----------
// The trigger button sits at the bottom of the Library page aside (Library.module.scss sets its width).
// Same look as the common `.filter-button` (scss/common/_filter-drawer.scss), but auto width
// so the "Filter by Requirement" label fits.
.requirement_filter_button:global(.MuiButton-root) {
  height: 44px;
  padding: 10px 16px;
  border: 1px solid colors.$gray-variant-4;
  border-radius: 8px;
  text-transform: none;
  white-space: nowrap;
  color: colors.$dark-blue;
  background-color: colors.$base-white;

  &:hover {
    border-color: colors.$border-grey-2;
    background-color: colors.$base-white;
  }

  :global(.MuiButton-startIcon) {
    margin-left: 0;
    color: colors.$dark-blue;
  }

  &.requirement_filter_button_active {
    border-color: $requirement-blue-text;
    background-color: $requirement-blue-bg;
  }
}

// Transparent full-screen overlay right behind the filter block; a click on it closes the block.
.requirement_filter_overlay {
  position: fixed;
  inset: 0;
  z-index: 1199;
  background-color: transparent;
}

// Above the sticky table header and the page content, below MUI modals / snackbars.
.requirement_filter_popper {
  z-index: 1200;
}

// Tablet / mobile: pinned to the top left corner of the screen (see RequirementFilter.tsx),
// so the block must fit the viewport and scroll inside itself.
.requirement_filter_popper_pinned {
  max-width: calc(100vw - 16px);

  .requirement_filter_paper {
    max-height: calc(100vh - 16px);
    overflow-y: auto;
  }

  .requirement_filter_options {
    max-height: none;
  }
}

.requirement_filter_paper {
  min-width: 240px;
  padding: 16px;
  border-radius: 8px;
}

.requirement_filter_title {
  margin-bottom: 8px;
  color: colors.$dark-blue;
}

.requirement_filter_options {
  max-height: 320px;
  overflow-y: auto;
  flex-wrap: nowrap;
}

.requirement_filter_option {
  margin-left: -8px;
  margin-right: 0;
  color: colors.$dark-blue;
}

.requirement_filter_actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.requirement_filter_main_actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}

.requirement_filter_reset {
  min-width: 0;
  padding-left: 8px;
  padding-right: 8px;
  text-transform: none;
  color: colors.$dark-blue;
}

.file_type_chip {
  border-radius: 16px;
  padding: 2px 8px;
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
}

.empty_message {
  max-width: 228px;
  margin-left: auto;
  margin-right: auto;
  font-family: "Light Inter", sans-serif;
  font-style: italic;
  font-size: 0.875rem;
  line-height: 1.3125rem;
  text-align: center;
  color: colors.$dark-blue;
}

// Small green pill right after the template name.
.free_tag {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 2px 8px;
  font-family: "SemiBold Inter", sans-serif;
  font-size: 0.6875rem;
  line-height: 1rem;
  color: $requirement-green-text;
  background-color: $requirement-green-bg;
  border-radius: 999px;
}

// ---------- Responsive ----------
.copymodal {

  @media #{breakpoints.$tablet-mobile}{
    width: calc(100% - 32px) !important;
    left: 16px !important;
  }

}
